<script lang="ts">
    import cn from 'classnames';

    import { globalStore } from '@components/stores';
    import { Dialog, dialogStore } from '@components/ui/dialog';
    import { LL } from '@i18n/i18n-svelte';
    import { Button, ButtonTypes } from '@uikit/button';
    import { Font, FontTypes } from '@uikit/font';

    import s from './config-dialog.module.css';

    export let onConfirm: () => void;
    export let confirmText: string;
    export let cancelText = $LL.cancel();
    export let title: string;
    export let subtitle: string;
    export let confirmButtonColor: string = ButtonTypes.Color.Brand;
    export let onCancel: () => void = () => dialogStore.closeDialog();

    const confirmButtonProps = {
        ...(Object.values(ButtonTypes.Color).includes(confirmButtonColor as ButtonTypes.Color)
            ? { color: confirmButtonColor as ButtonTypes.Color }
            : {}),
        ...(Object.values(ButtonTypes.Color).includes(confirmButtonColor as ButtonTypes.Color)
            ? {}
            : { classes: cn(s[confirmButtonColor]) }),
    };
</script>

<Dialog classes={cn(s.root, { [s.desktop]: $globalStore.isDesktopSite })}>
    <Font
        type={FontTypes.Type.h3}
        color={FontTypes.Color.Invert}
        tagName={FontTypes.TagName.h3}
        isBold
        className={s.title}
        attrs={{ 'data-testid': 'title' }}
    >
        {title}
    </Font>
    <Font
        type={FontTypes.Type.body}
        color={FontTypes.Color.Secondary}
        tagName={FontTypes.TagName.p}
        className={s.subtitle}
        attrs={{ 'data-testid': 'subtitle' }}
    >
        {subtitle}
    </Font>

    <div class={s.buttonsWrapper}>
        <Button
            color={ButtonTypes.Color.Secondary}
            on:click={onCancel}
            attrs={{ 'data-testid': 'cancelButton' }}
        >
            {cancelText}
        </Button>
        <Button
            {...confirmButtonProps}
            on:click={onConfirm}
            attrs={{ 'data-testid': 'confirmButton' }}
        >
            {confirmText}
        </Button>
    </div>
</Dialog>